import { FORM_LABELS } from '../store/constants'

/**
 * Class representing IntervalValidation for validating intervals and checking for conflicts.
 *
 * @author Isadora Botassari
 * @class
 * @name IntervalValidation
 */
export default class IntervalValidation {

    // returns true if distribution is valid; false otherwise
    static validateIntervalDist = (intervalList) => {

        // interval distribution is empty; not valid
        if (intervalList.length < 1) {
            return false
        }

        // interval distribution has a single 0 - 100 interval; valid
        if (intervalList.length == 1 && intervalList[0].minValue === 0 && intervalList[0].maxValue === 100) {
            return true
        }

        // NONE operator was chosen, interval distribution is irrelevant; valid
        if (intervalList.length == 1 && intervalList[0].operator === FORM_LABELS.NONE) {
            return true
        }

        const sortedArray = intervalList.slice().sort((a, b) => a.minValue - b.minValue)
        // interval distribution does not start at 0 or ends at 100, thus it's incomplete; not valid
        if (sortedArray[0].minValue !== 0 || sortedArray[sortedArray.length - 1].maxValue !== 100) {
            return false
        }

        // interval distribution has 'holes' on it, meaning it's not continuous; not valid 
        for (let i = 0; i < (intervalList.length - 1); i++) {
            if ((sortedArray[i + 1].minValue - sortedArray[i].maxValue) !== 1) {
                return false
            }
        }

        return true
    }

    // checks if there is an intersection of two intervals; returns true if there is a conflict, false otherwise
    static validateIntervalConflict = (newInterval, intervalList) => {

        for (let interval of intervalList) {
            // i1 < i2 < f1 < f2
            if ((interval.minValue <= newInterval.minValue) && (newInterval.minValue <= interval.maxValue) && (interval.maxValue <= newInterval.maxValue)) {
                return { state: true, interval: interval }
            }
            // i1 < i2 < f2 < f1
            if ((interval.minValue <= newInterval.minValue) && (newInterval.maxValue <= interval.maxValue)) {
                return { state: true, interval: interval }
            }

            // i2 < i1 < f1 < f2
            if ((newInterval.minValue <= interval.minValue) && (interval.maxValue <= newInterval.maxValue)) {
                return { state: true, interval: interval }
            }

            // i2 < i1 < f2 < f1 
            if ((newInterval.minValue <= interval.minValue) && (interval.minValue <= newInterval.maxValue) && (newInterval.maxValue <= interval.maxValue)) {
                return { state: true, interval: interval }
            }
        }

        return { state: false, interval: {} }
    }

    /* checks if NONE operator is being used properly. 
    the user is not allowed to create a new range with NONE operator if there are previous ranges */
    static validateNoneOperatorOnSubmit = (newInterval, intervalList) => {

        if (newInterval.operator === FORM_LABELS.NONE && intervalList.length > 0)
            return false

        return true
    }

}